var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"padding_side"},[_c('competition-list-component',{attrs:{"competition-type":'competitionUserMy',"member-key":_vm.UserInfo.mb_no}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }